import { FC, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RootState } from "../../../app/Store";
import Button from "../../../components/UI/Button/Button";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteEmailNotification,
  getNotificationDetail,
  updateDeleteStatus,
} from "../../../features/emailNotifications";
import { transformDate } from "../../../Utility/Utility";
import ViewHeader from "../../../components/ViewHeader/ViewHeader";
import { adminRouts } from "../../../routs";
import {
  Wapper,
  Form,
  ElementWrapper,
  TwoElements,
  Label,
  Value,
  BtnWrapper,
} from "./StyledNotificationDetail";
import {
  EmptyImgSection,
  Image,
  ImageContainer,
  ImageSection,
  ImageWrapper,
  IndImgWrapper,
  Title,
  TitleWrapper,
} from "../../Forms/Lottery/CreateLottery/RepeatedLottery/StyledCreateLottery";

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
}

const NotificatoinDetail: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { notificationId }: any = useParams();

  const detail: any = useSelector(
    (state: RootState) => state.emailNotifications.emailNotificationDetail
  );
  const isDeleted = useSelector(
    (state: RootState) => state.emailNotifications.isDeleted
  );
  console.log(detail);

  useEffect(() => {
    if (notificationId !== null && notificationId !== undefined) {
      dispatch(getNotificationDetail(parseInt(notificationId)));
    }
  }, [notificationId]);

  useEffect(() => {
    if (isDeleted) {
      navigate(adminRouts.emailNotificationList);
      return () => {
        dispatch(updateDeleteStatus({ isDeleted: false }));
      };
    }
  }, [isDeleted]);

  let view = <div></div>;

  if (Object.keys(detail).length > 0) {
    let emailSub = (
      <ElementWrapper>
        <Label>Subject</Label>
        <Value>{detail.emailSubject}</Value>
      </ElementWrapper>
    );

    let emailBody = (
      <ElementWrapper>
        <Label>Body</Label>
        <Value>{detail.emailBody}</Value>
      </ElementWrapper>
    );

    let scheduleDateAndUserType = (
      <TwoElements>
        <ElementWrapper>
          <Label>Schedule Date</Label>
          <Value>{transformDate(detail.emailScheduleDate)}</Value>
        </ElementWrapper>
        <ElementWrapper>
          <Label>User Type</Label>
          <Value>{detail.emailUserType}</Value>
        </ElementWrapper>
      </TwoElements>
    );

    view = (
      <>
        {emailSub}
        {emailBody}
        {scheduleDateAndUserType}
      </>
    );
  }

  const deleteEmail = () => {
    dispatch(deleteEmailNotification(`emailNotificationId=${notificationId}`));
  };
  const redirectToEditEmail = () => {
    navigate(adminRouts.editEmailNotification(notificationId));
  };

  return (
    <>
      <ViewHeader
        title={`Email details / ${notificationId}`}
        isBackButtonRequired={true}
        backButtonRedirectionUrl={adminRouts.emailNotificationList}
      />
      <Wapper>
        <Form>{view}</Form>
        
        {detail.isActive && (
            <>
            <ImageSection>
            <ImageContainer>
              <TitleWrapper>
                <Title>Attachments</Title>
              </TitleWrapper>
              <ImageWrapper>
                {detail?.rewardImages !== null ? (
                  <>
                    {detail?.emailAttachmentUrls?.map((imgUrl: any) => {
                      return (
                        <IndImgWrapper>
                          <Image src={imgUrl} alt={"attachments"} key={imgUrl} />
                        </IndImgWrapper>
                      );
                    })}
                  </>
                ) : (
                  <>
                    <EmptyImgSection>
                      <div>No Images Found</div>
                    </EmptyImgSection>
                  </>
                )}
              </ImageWrapper>
            </ImageContainer>
          </ImageSection>
          <BtnWrapper>
            {detail?.emailSentCount === 0 && (
              <Button
                title={"Edit Notification"}
                btnSize={ButtonSize.md}
                btnVariant={ButtonVariant.primaryFilled}
                clicked={redirectToEditEmail}
              />
            )}

            <Button
              title={"Delete Notification"}
              btnSize={ButtonSize.md}
              btnVariant={ButtonVariant.danger}
              clicked={deleteEmail}
            />
          </BtnWrapper>
            </>
        )}
      </Wapper>{" "}
    </>
  );
};

export default NotificatoinDetail;
